export default __webpack_public_path__ + "static/media/check-square.b259776b.svg";